import {
  queryOptions,
  useQuery,
  useInfiniteQuery,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { apiClient } from "@/lib/api/client";
import type {
  DashboardMeResponse,
  DashboardGuildsResponse,
} from "@/lib/api/types";

export const dashboardKeys = {
  all: ["dashboard"] as const,
  me: () => [...dashboardKeys.all, "me"] as const,
  guilds: () => [...dashboardKeys.all, "guilds"] as const,
};

export const dashboardMeQueryOptions = queryOptions({
  queryKey: dashboardKeys.me(),
  queryFn: () =>
    apiClient.get<DashboardMeResponse>("/api/dashboard/me").then((r) => r.data),
});

export function useDashboardMe() {
  return useQuery(dashboardMeQueryOptions);
}

export function useDiscordGuilds() {
  return useInfiniteQuery({
    queryKey: dashboardKeys.guilds(),
    queryFn: ({ pageParam }) => {
      const params = new URLSearchParams();
      params.set("limit", "50");
      if (pageParam) {
        params.set("cursor", pageParam);
      }
      return apiClient
        .get<DashboardGuildsResponse>(
          `/api/dashboard/guilds?${params.toString()}`
        )
        .then((r) => r.data);
    },
    initialPageParam: null as string | null,
    getNextPageParam: (lastPage) => lastPage.data.nextCursor,
  });
}

export function useRefreshDiscordGuilds() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      apiClient
        .delete<{ data: { cleared: boolean } }>("/api/dashboard/guilds/cache")
        .then((r) => r.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: dashboardKeys.guilds() });
    },
  });
}
